import { render, staticRenderFns } from "./ReservationTime.vue?vue&type=template&id=8b10aaaa&"
import script from "./ReservationTime.vue?vue&type=script&lang=ts&"
export * from "./ReservationTime.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports